import React from 'react'
import Icon from '../../../../elements/Icon/Icon'
import header from './dictionaries/header'
import classes from './style.module.css'

const ItemHeader = (props) => {

    const { key, item, tooltip } = props

    switch (item) {
        // case 'createdAt':
        //     return (
        //         <th key={key}>
        //             <div className={classes.tooltip} dataTooltip={'отправки юзером, не майнинга в блокчейне'}>
        //                 {header[item] || item}
        //                 <div className={classes.icon}>
        //                     <Icon icon={'INFO'} size={20} color={'#FFF'} />
        //                 </div>
        //             </div>
        //         </th>
        //     )
        case 'txStatus':
            return (
                <th key={key}>
                    {tooltip ?
                        <div className={classes.tooltip} dataTooltip={`found_block - вошла в блокчейн;\nfail_validated - нода отклонила транзу;\nvalidated - нода приняла транзу;\nnot_found - не найдена в блокчейне`}>
                            {header[item] || item}
                            <div className={classes.icon}>
                                <Icon icon={'INFO'} size={20} color={'#FFF'} />
                            </div>
                        </div> :
                        <>
                            {header[item] || item}
                        </>}
                </th>
            )
        case 'selectedFee':
            return (
                <th key={key}>
                    <div className={classes.tooltip} dataTooltip={`"langMsg":"eth_speed_slow", - текстовая надпись\nвыбранного варианта оплаты;\n"gasPrice":"886889381", "gasPriceGwei":"0.8868893",\n"gasLimit":"70200", "feeForTx":"62259634546200" - \nполя собственно фи;\n"nonceForTx":0 - значение выбранного нонса;\n"nonceLog":"replacedByUi 0 recheck oldNonce 0 with\nbasic -1 customFeeNonce 0 from serverCheck used\nnewNonce noMax => -1 nonceForTxBasic -1" - как \nформировался нонс, тут например это юзер сам\nвыбрал хотя ему предлагало -1 много раз - т.е.\nдефолтный отправить тк не было очереди;\n"needSpeed":"88688"-что рекомммендует ставить по газфи;\n"amountForTx":"10000000000000000" - сумма транзы;\n"isCustomFee":true - юзер кликал кастом фии;
                    `}>
                        {header[item] || item}
                        <div className={classes.icon}>
                            <Icon icon={'INFO'} size={20} color={'#FFF'} />
                        </div>
                    </div>
                </th>
            )
        default:
            return (
                <th key={key}>
                    {header[item] || item}
                </th>
            )
    }



}

export default ItemHeader